import React, { FC } from 'react';

import classNames from 'classnames';
import { prop } from 'ramda';

import BaseMask from 'components/shared/FormAdapters/FormBase/Mask';

import styles from './index.module.css';
import { IMaskedInputProps } from './types';

const MaskedInput: FC<IMaskedInputProps> = ({
  size,
  isError,
  disabled,
  readOnly,
  postfix,
  className,
  inputType,
  ...props
}) => {
  const defaultInputContainerClasses = classNames(
    styles.inputContainer,
    size && prop(`inputContainer-${size}`, styles),
    postfix && prop('inputContainer-withPostfix', styles),
    disabled && prop('inputContainer-disabled', styles),
    isError && prop('inputContainer-isError', styles),
  );

  const defaultInputClasses = classNames(
    styles.input,
    postfix && prop('input-withPostfix', styles),
    readOnly && prop('input-readOnly', styles),
    className,
  );

  const type = inputType || 'text';

  return (
    <div className={defaultInputContainerClasses}>
      {/*@ts-ignore*/}
      <BaseMask {...props} type={type} className={defaultInputClasses} disabled={disabled} readOnly={readOnly} />
      {postfix && <div className={styles.postfix}>{postfix}</div>}
    </div>
  );
};

export default MaskedInput;
